import Mock from 'mockjs';
import { param2Obj } from '../src/utils';

const ListType = [
    {
        resultMemo: '混油肌',
        uniqueID: 19,
        categoryId: 14,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '普通肌',
        uniqueID: 18,
        categoryId: 14,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '干性肌',
        uniqueID: 17,
        categoryId: 14,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '油性肌',
        uniqueID: 20,
        categoryId: 14,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '敏感肌',
        uniqueID: 14,
        categoryId: 12,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '耐受肌',
        uniqueID: 13,
        categoryId: 12,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '皱纹肌',
        uniqueID: 22,
        categoryId: 15,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '紧致肌',
        uniqueID: 21,
        categoryId: 15,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '色素肌',
        uniqueID: 16,
        categoryId: 13,
        timestamp: +Mock.Random.date('T'),
    },
    {
        resultMemo: '非色素肌',
        uniqueID: 15,
        categoryId: 13,
        timestamp: +Mock.Random.date('T'),
    },
];

const ListCatogery = [
    {
        name: '混油肌',
        uniqueID: 14,
        desc: 'test',
        timestamp: +Mock.Random.date('T'),
    },
    {
        name: '敏感肌',
        uniqueID: 12,
        desc: 'test',
        timestamp: +Mock.Random.date('T'),

    },
    {
        name: '皱纹肌',
        uniqueID: 15,
        desc: 'test',
        timestamp: +Mock.Random.date('T'),

    },
    {
        name: '色素肌',
        uniqueID: 13,
        desc: 'test',
        timestamp: +Mock.Random.date('T'),
    },
];


const count = 100;

const baseContent = '<p>我是测试数据我是测试数据</p><p><img src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>';
const imageUri = 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3';

const mapName: Map<number, string> = new Map();
for (const iterator of ListCatogery) {
    mapName.set(iterator.uniqueID, iterator.name);
}
export default {
  getTypeList: (config) => {
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url);

    let mockList = ListType.filter((item) => {
      if (type && item.categoryId !== type) { return false; }
      if (title && item.resultMemo.indexOf(title) < 0) { return false; }
      return true;
    });

    for (const iterator of mockList) {
        (iterator as any).categoryName = mapName.get(iterator.categoryId);
    }

    if (sort === '-id') {
      mockList = mockList.reverse();
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1));

    return {
        code: 1000,
        data: {
          total: mockList.length,
          items: pageList,
        },
    };
  },

  getCatogeryList: (config: { url: any; }) => {
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url);

    let mockList = ListCatogery.filter((item) => {
      if (title && item.name.indexOf(title) < 0) { return false; }
      return true;
    });

    if (sort === '-id') {
      mockList = mockList.reverse();
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1));

    return {
        code: 1000,
        data: {
          total: mockList.length,
          items: pageList,
        },
    };
  },

  createArticle: () => ({
    data: 'success',
  }),
  updateArticle: () => ({
    data: 'success',
  }),
};
